// Editable Rate/Pc on Place Order (Corporate & Projects customers only).
// A typed rate is saved as the line's ₹ discount off MRP — the same custom
// per-line discount the Enquiry form uses — so the Sales Order, Dispatch Order
// and Invoice all price the line at that rate.

const r2 = (n: number) => Math.round(n * 100) / 100;

/** The Rate/Pc to use: the typed rate, kept between 0 and MRP, or the tier rate when nothing valid is typed. */
export function effectiveRate(mrp: number, tierRate: number, typed: string | undefined): number {
  if (typed == null || typed.trim() === '') return tierRate;
  const n = Number(typed);
  if (!Number.isFinite(n)) return tierRate;
  return r2(Math.min(mrp, Math.max(0, n)));
}

/** The line's ₹ discount off MRP that prices it at `rate` — or undefined when the rate is the tier rate (nothing to send). */
export function rateToDiscountAmt(mrp: number, qty: number, rate: number, tierRate: number): number | undefined {
  if (r2(rate) === r2(tierRate)) return undefined;
  return r2(Math.max(0, mrp - rate) * qty);
}
